<template>
  <div class="motor-images-display" v-if="getSelectedMotorById">
    <img :src="getFromStorage(getSelectedMotorById.image_top_view_path)" class="motor-image-top">
    <img :src="getFromStorage(getSelectedMotorById.image_front_view_path)" class="motor-image-front">
    <img :src="getFromStorage(getSelectedMotorById.image_side_view_path)" class="motor-image-side">
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import { getFromStorage } from "@/helpers/backendStorage";

export default {
  name: 'MotorImages',
  methods: { getFromStorage },

  computed: {
    ...mapGetters({
      getMotorById: 'build/motorConfig/motors/byId',
      preferences: 'build/motorConfig/getMotorPreferences',
    }),
    getSelectedMotorById() {
      return this.getMotorById[this.preferences.selectedMotor];
    },
  },
};
</script>

<style scoped lang="scss">
.motor-images-display {
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(8, 1fr);
  grid-column-gap: 20px;
  width: 100%;
  height: 100%;
}

.motor-image-top {
  margin-top: 12px;
  grid-row: 1 / 3;
  grid-column: 2 / 7;
  max-width: 100%;
  height: auto;

  @media only screen and (min-width: 768px) {
    grid-column: 1 / 4;
  }
}

.motor-image-front {
  display: none;
  grid-row: 1 / 2;
  grid-column: 4 / 6;
  max-width: 100%;
  height: auto;

  @media only screen and (min-width: 768px) {
    display: block;
  }
}

.motor-image-side {
  display: none;
  grid-row: 1 / 2;
  grid-column: 6 / 8;
  max-width: 100%;
  height: auto;

  @media only screen and (min-width: 768px) {
    display: block;
  }
}
</style>
